<template>

  <div v-if="$route.name === 'DocumentTemplateCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'DocumentTemplateList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="item"
                  :violations="violations"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>

  <b-row v-else>
    <b-col>
      <Form
        :handle-submit="onSendForm"
        :values="item"
        :violations="violations"/>
    </b-col>
  </b-row>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        idDefaultBatchNumber: null,
        idCaseType: null,
        idTaskType: null
      }
    }
  },
  watch: {
    created (val) {
      if (val && this.$route.name === 'DocumentTemplateCreate') {
        this.$router.push({ name: 'DocumentTemplateList' })
      }
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'DocumentTemplateCreate')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'documenttemplate/create/created',
      violations: 'documenttemplate/create/violations',
      isLoading: 'documenttemplate/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'documenttemplate/create/create',
      reset: 'documenttemplate/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
